import React, { useState, useEffect, useMemo } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useAppContext } from '../AppContext';

const useUrlQuery = () => {
    return useMemo(() => new URLSearchParams(window.location.search), [window.location.search]);
};

const ShowdownSpectatorPage = () => {
    const { db, appId } = useAppContext();
    const query = useUrlQuery();
    const showdownId = query.get('showdownId');

    const [showdown, setShowdown] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!showdownId || !db) {
            setError('No Showdown ID provided in the URL.');
            setIsLoading(false);
            return;
        }

        const fetchShowdown = async () => {
            setIsLoading(true);
            try {
                const showdownRef = doc(db, `artifacts/${appId}/public/data/challenges`, showdownId);
                const docSnap = await getDoc(showdownRef);

                if (docSnap.exists()) {
                    setShowdown({ id: docSnap.id, ...docSnap.data() });
                } else {
                    setError('Showdown not found.');
                }
            } catch (err) {
                console.error("Error fetching showdown:", err);
                setError('Failed to load showdown data.');
            }
            setIsLoading(false);
        };

        fetchShowdown();
    }, [showdownId, db, appId]);

    if (isLoading) {
        return <div className="text-center p-8"><p className="text-white text-xl">Loading Showdown Replay...</p></div>;
    }

    if (error) {
        return <div className="text-center p-8"><p className="text-red-400 text-xl">{error}</p></div>;
    }

    if (!showdown) {
        return <div className="text-center p-8"><p className="text-yellow-400 text-xl">Could not load showdown data.</p></div>;
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-80 rounded-lg p-4">
            <h1 className="text-4xl font-bold text-purple-400 mb-2">Showdown Replay</h1>
            <h2 className="text-2xl text-white mb-4">{showdown.title || 'Untitled Showdown'}</h2>
            <div className="w-full max-w-3xl h-96 bg-black rounded-lg p-4 overflow-y-auto font-mono text-sm text-gray-300 border border-gray-700">
                <p className="text-green-400">Match Log:</p>
                {(showdown.matchLog || []).map((log, index) => (
                    <p key={index} className="whitespace-pre-wrap">{`[Turn ${index + 1}] ${log}`}</p>
                ))}
                {showdown.winnerNexusId && <p className="mt-4 text-yellow-400 font-bold">Winner: Nexus {showdown.winnerNexusId}</p>}
            </div>
        </div>
    );
};

export default ShowdownSpectatorPage;
